import { render } from "./Login.vue?vue&type=template&id=5511d6e8"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=5511d6e8&lang=css"

import exportComponent from "/data/deploy/code/save-ocr-ionic/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__